import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"system-location"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M22.25 16.75C22.25 20.0035 18.5 22.5 18.5 22.5C18.5 22.5 14.75 20.0035 14.75 16.75C14.75 14.6789 16.4289 13 18.5 13C20.5711 13 22.25 14.6789 22.25 16.75Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 10V3H2V17H11M4 21H11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M18.25 17H18.75M22.25 16.75C22.25 20.0035 18.5 22.5 18.5 22.5C18.5 22.5 14.75 20.0035 14.75 16.75C14.75 14.6789 16.4289 13 18.5 13C20.5711 13 22.25 14.6789 22.25 16.75Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SystemLocation = Vue.extend<IconProps>({
  name: 'SystemLocationIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'system-location',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default SystemLocation;
